import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import date from '@/utils/date';
import { getFileOriginEditor, getWorkbookWarningMsg } from '@/utils/spreadsheets';
import WorkbookIcon from '@/components/misc/WorkbookIcon';
import GoogleDriveSyncBadge from '@/features/Workbooks/GoogleDriveSyncBadge';
import TooltipIcon from '@/features/Workbooks/TooltipIcon';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const WorkbookCard = _ref => {
  let {
    title,
    elementId,
    createdAt,
    updatedAt,
    originFileType,
    syncConfig,
    syncStatus,
    warnings,
    isFeatured = false,
    onClick
  } = _ref;
  const metadata = [`Created on ${date.toFullTextDate(createdAt)}`, `Last updated ${date.toTimeFromDate(updatedAt)}.`].join('. ');
  const isSyncingGoogleSheet = getFileOriginEditor(originFileType) === 'google-sheets' && syncConfig;
  const isNotSyncing = syncStatus !== 'active';
  const warningMsg = getWorkbookWarningMsg(warnings);
  const hasBadges = isSyncingGoogleSheet || isNotSyncing || warningMsg;
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    className: clsx(styles.card, {
      [styles['card--featured']]: isFeatured
    })
  }, elementId && {
    id: elementId
  }), onClick ? {
    onClick
  } : {}), {}, {
    children: [/*#__PURE__*/_jsx(WorkbookIcon, {
      originFileType: originFileType
    }), /*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: styles.metadata,
      children: metadata
    }), hasBadges ? /*#__PURE__*/_jsxs("div", {
      className: styles.badges,
      children: [isSyncingGoogleSheet ? /*#__PURE__*/_jsx(GoogleDriveSyncBadge, {}) : null, warningMsg ? /*#__PURE__*/_jsx(TooltipIcon, {
        content: warningMsg,
        variant: "warning",
        icon: "warning"
      }) : null, isNotSyncing ? /*#__PURE__*/_jsx(TooltipIcon, {
        icon: "disconnect",
        content: "Sync is not active"
      }) : null]
    }) : null]
  }));
};

export default WorkbookCard;